import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent implements OnInit {

  @Input() msjError:string='Error';
  constructor() { }

  ngOnInit(): void {
  }

}